module.exports = __webpack_public_path__ + "static/media/storeLogo.f2227654.jpg";